import getOr from "lodash/fp/getOr";

const selectProductSelectorStyle = getOr("default", [
  "app",
  "formData",
  "productSelectorStyle",
]);

export default selectProductSelectorStyle;
